export const FONT_SIZES = {
  PARAGRAPH: { xs: "1rem", sm: "1.2rem" },
  SUBTITLE: { xs: "1.2rem", sm: "1.5rem" },
  TITLE: { xs: "1.5rem", sm: "2rem" },
  TEXT_HINT: { xs: "0.8rem", sm: "1.2rem" },
  ICON: "small",
  TABLE_COLUMN: { xs: "1rem", sm: "1.1rem" },
  TABLE_CELL: { xs: "0.8rem", sm: "1rem" },
  BUTTON_TEXT_MEDIUM: { xs: "0.8rem", sm: "1rem" },
};
